// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreDetailsButton__container--1ID","btn":"MoreDetailsButton__btn--pxa"};